export enum RoleNames {
    AdministratorRoleName = 'Administrators',
    ModeratorsRoleName = "Moderators",
    RegisteredRoleName = 'Registered',
    GuestRoleName = 'Guests',
    EmployeeRoleName = 'Employees',
    TraderRoleName = 'Traders'
}
